module.exports = __webpack_public_path__ + "media/images/emblems/Quarten-bc955f2248e088efa43ccbf93850ce4a.png";